import { create } from "zustand";
import { RemindersSlice, createRemindersStore } from "./reminders.store";

export const useRemindersStore = create<RemindersSlice>((...args) => ({
	...createRemindersStore(...args),
}));
